import React, { useContext } from 'react';
import { SET_SEARCH_ORDER_ITEM, SET_SEARCH_ORDER_ITEM_LOADING, SET_SEARCH_TEXT } from './SearchOrderItemContext';
import axios from '../../utils/axios';
import constants from '../../utils/constants';
import moment from "moment";


const SearchOrderItemsData = (data, orderItemCtx) => {
    orderItemCtx.dispatch({ type: SET_SEARCH_ORDER_ITEM, searchorderItems: data });
}

const setSearchTextData = (data, orderItemCtx) => {
    orderItemCtx.dispatch({ type: SET_SEARCH_TEXT, searchText: data });
}


// .dispatch({ type: SET_SEARCH_TEXT, searchText: search })

// const SearchOrderItemsObject = (object, orderItemCtx) => {
//     orderItemCtx.dispatch({ type: SET_SEARCH_ORDER_ITEM, orderItems: [...orderItemCtx.orderItems, object] });
// }


const searchOrderItems = (
    orderItemCtx,
    projectId,
    offset,
    orderBy,
    orderAsc,
    key,
    filter,
    callback,
    selectedLocationId,
    currentPageSize
) => {
    orderItemCtx.dispatch({ type: SET_SEARCH_ORDER_ITEM_LOADING, searchorderItemsLoading: true });
    let link = `${constants.URL_ORIGIN}/entity/order/lineitem/?pagination_limit=${currentPageSize}&category=all`;
    if (selectedLocationId && selectedLocationId >= 0) link = `${link}&location_id=${selectedLocationId}`;
    if (projectId && projectId >= 0) link = `${link}&project_id=${projectId}`;
    if (offset) link = `${link}&pagination_offset=${offset}`;
    if (key) link = `${link}&search_query=${key}`;
    if (orderBy) link = `${link}&order_by=${orderBy}`;
    if (orderAsc) link = `${link}&order_asc=${orderAsc}`;
    // if (filter && filter.statusString) link = `${link}&status=${filter.statusString}`;
    if (filter && filter.category && filter.category.length > 0) link = `${link}&type=${filter.category.join(',')}`;

    if (filter && filter.vendor) link = `${link}&vendor_name=${filter.vendor}`;
    if (filter && filter.color) link = `${link}&color=${filter.color}`;

    if (filter && filter.sku) link = `${link}&sku=${filter.sku}`;

    if (filter && filter.po) link = `${link}&po=${filter.po}`;
    if (filter && filter.minQty > 0) link = `${link}&qty_from=${filter.minQty}`;
    if (filter && filter.maxQty > 0) link = `${link}&qty_to=${filter.maxQty}`;

    return axios
        .get(link)
        .then(response => {
            orderItemCtx.dispatch({ type: SET_SEARCH_ORDER_ITEM, searchorderItems: response.data });
            orderItemCtx.dispatch({ type: SET_SEARCH_ORDER_ITEM_LOADING, searchorderItemsLoading: false });
            callback({ success: true, data: response.data });
        })
        .catch(err => {
            orderItemCtx.dispatch({ type: SET_SEARCH_ORDER_ITEM_LOADING, searchorderItemsLoading: false });

            callback({ success: false, data: err })
        });
};



export default {
    SearchOrderItemsData,
    searchOrderItems,
    setSearchTextData
}